import { useEffect, useRef, useState } from 'react';
import { BASE_WS_URL } from '../config/config';

// Lightweight, component-local WebSocket hook for settled round events
// Does not use the global Redux socket to avoid disconnecting the betting socket
export default function useSettledRounds(gameId, roundId) {
  const [message, setMessage] = useState(null);
  const [status, setStatus] = useState('disconnected');
  const socketRef = useRef(null);

  useEffect(() => {
 
    if ( !roundId) return;

    const endpoint = `${BASE_WS_URL}/settled-rounds?roundId=${encodeURIComponent(roundId)}`;
    try {
      socketRef.current = new WebSocket(endpoint);
    } catch (err) {
      setStatus('error');
      return;
    }

    const socket = socketRef.current;
    setStatus('connecting');

    socket.onopen = () => setStatus('connected');

    socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
     
        const payloadGameId = data?.data?.gameId ?? data?.gameId;
        const payloadRoundId = data?.data?.roundId ?? data?.roundId;
   
        if (String(payloadRoundId) !== String(roundId)) return;
        if (data?.type !== 'ROUND_SETTLED') return;
        setMessage(data);
      } catch {
        
      }
    };

    socket.onerror = () => setStatus('error');
    socket.onclose = () => setStatus('disconnected');

    return () => {
      try {
        socket.close();
      } catch {}
      socketRef.current = null;
    };
  }, [gameId, roundId]);

  return { settledData: message, settledConnected: status === 'connected' };
}


